import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const dashboardApi = createApi({
  reducerPath: "dashboard/api",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL_DEVELOP}`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("techsbook_customer_portal_token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
        headers.set("time", String(Date.now()));
      }

      return headers;
    },
  }),
  keepUnusedDataFor: 0.0001,
  endpoints: (build) => ({
    getCertificates: build.query({
      query: () => ({
        url: `/certificates`,
        method: "GET",
      }),
    }),
    getTechnicians: build.query({
      query: (params) => ({
        url: `/technicians?${params}`,
        method: "GET",
      }),
    }),
    getAllTechniciansLocations: build.query({
      query: () => ({
        url: `/technicians/locations`,
        method: "GET",
      }),
    }),
    getTutorial: build.query({
      query: () => ({
        url: `/onboarding-tutorial`,
        method: "GET",
      }),
    }),
    toggleRefer: build.query({
      query: ({id}) => ({
        url: `/technicians/${id}/toggle-favorite`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useLazyGetCertificatesQuery,
  useLazyGetTechniciansQuery,
  useLazyGetTutorialQuery,
  useLazyGetAllTechniciansLocationsQuery,
  useLazyToggleReferQuery,
} = dashboardApi;
